<template>
  <div :class="wrapperClass">
    <label v-if="showLabel" :for="id" :class="labelClass">{{
      labelText
    }}</label>

    <Multiselect
      style="height: 40px"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="model"
      class="US-multiselect"
      :aria-label="ariaLabel"
      deselect-label=""
      deselect-group-label=""
      select-group-label=""
      select-label=""
      selected-label=""
      preserve-search
      searchable
      :clear-on-select="false"
      :multiple="false"
      :internal-search="true"
      :id="id"
    >
      <template #noOptions> {{ noOptionsText }} </template>
      <template #noResult> {{ noResultText }} </template>
      <template #option="{ option }">
        <span v-if="option === ''">Todos</span>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "USMultiselectInput",
  components: {
    Multiselect,
  },
  inheritAttrs: false,
  props: {
    wrapperClass: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    noOptionsText: {
      type: String,
      default: "Nenhuma opção encontrada",
    },
    noResultText: {
      type: String,
      default: "Nenhum resultado encontrado",
    },
    value: {
      type: [Object, Array, String],
      default: () => ({}),
    },
    labelText: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss">
.US-multiselect .multiselect__select {
  height: 100%;
}
</style>
